import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { ClipLoader } from "react-spinners";

import { useGetPrivacyAndTerms, useUpdatePrivacyAndTerms } from "../../apis";
import { PrivacyForm, PrivacyFormValues } from "../../components";
import { getInitialPrivacyFormValues } from "../../helpers";

import styles from "./Privacy.module.scss";

const PRIVACY_FORM_ID = "privacy-form-id";

const Privacy = () => {
  const { t } = useTranslation();
  const { privacyAndTerms, isLoading } = useGetPrivacyAndTerms();

  const { mutate: mutateUpdatePrivacyAndTerms, isLoading: isLoadingUpdate } =
    useUpdatePrivacyAndTerms({
      onSuccess: () => {
        toast.success(
          t("Privacy Policy and Terms of Service updated successfully")
        );
      }
    });

  const handleFormSubmit = (formData: PrivacyFormValues) => {
    const body = {
      privacyPolicy: formData.privacy,
      termsOfService: formData.terms
    };
    mutateUpdatePrivacyAndTerms(body);
  };

  return (
    <div className={styles.privacy}>
      {!isLoading ? (
        <>
          <PrivacyForm
            formId={PRIVACY_FORM_ID}
            onSubmit={handleFormSubmit}
            defaultValues={getInitialPrivacyFormValues(privacyAndTerms)}
            isLoadingUpdate={isLoadingUpdate}
          />
        </>
      ) : (
        <div className={styles.privacy_loader}>
          <ClipLoader size={50} color="#fb3973" />
        </div>
      )}
    </div>
  );
};

export default Privacy;
